import { FuriganaHorizontalIcon } from './FuriganaHorizontalIcon';

/**
 * author: Haley Halcyon
 * id D9CC1449-7E53-4305-A521-C4E705390012
 * name furigana-horizontal
 * version: 4.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/furigana-horizontal.svg
 * tags
 * - Text / Content / Format 
 */
export const RubyHorizontalIcon = FuriganaHorizontalIcon;
export default RubyHorizontalIcon